import { useContext } from 'react';
import { IconButton, Tooltip, Zoom } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { customTooltipStyles as classes } from './CustomTooltipStyles';
import { TOOLTIP_ALTMSG, TOOLTIP_POSITION_RIGHT, TOOLTIP_POSITION_TOP } from '../../constants';
import { commonTernary, isWebComponentFlow } from '../commonCode';
import { InfoIcon } from '../../images/svg/CustomizedSVG';
import LeadGenerationContext from '../../context/LeadGenerationContext';

function CustomTooltip({
  text,
  customAriaLabel,
  placement,
  custom,
  widthConsumer,
  tabIndex,
  isBundleCompliance = false,
  disablePadding = false,
}) {
  const { t } = useTranslation();
  const baseContext = isWebComponentFlow();

  return (
    <Tooltip
      title={text || ''}
      arrow={false}
      placement={isMobile ? TOOLTIP_POSITION_TOP : placement || TOOLTIP_POSITION_RIGHT}
      leaveTouchDelay={10000}
      enterTouchDelay={50}
      leaveDelay={500}
      TransitionComponent={Zoom}
      slotProps={{
        tooltip: {
          sx: isBundleCompliance ? classes.tooltipBundle : classes.tooltip,
        },
        arrow: {
          sx: classes.arrow,
        },
      }}
    >
      <IconButton
        aria-label={
          t(customAriaLabel, { defaultValue: customAriaLabel }) ||
          t(text, { defaultValue: text }) ||
          t(TOOLTIP_ALTMSG, { defaultValue: TOOLTIP_ALTMSG })
        }
        aria-roledescription="More Info"
        sx={{ padding: disablePadding ? undefined : 0 }}
      >
        <InfoIcon
          width={widthConsumer ? '24px' : commonTernary(custom, '13px', '20px')}
          height={widthConsumer ? '24px' : commonTernary(custom, '13px', '20px')}
          // tabIndex={0}
          color={baseContext?.theme?.palette?.orientalPrimary?.main}
        />
      </IconButton>
    </Tooltip>
  );
}

export default CustomTooltip;

CustomTooltip.propTypes = {
  text: PropTypes.string,
  customAriaLabel: PropTypes.string,
  placement: PropTypes.string,
  custom: PropTypes.bool,
  widthConsumer: PropTypes.bool,
  tabIndex: PropTypes.number,
  isBundleCompliance: PropTypes.bool,
  disablePadding: PropTypes.bool,
};
